import { createContext, useContext } from 'react';

const ProducaoContext = createContext();

export const ProducaoProvider = ({ children }) => {
  const today = new Date();
  
  const buscarProducoes = async (mes, ano, idRestaurante, idResponsavel) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const isValid = (v) => v != null && v !== "" && String(v) !== "undefined";
      const params = new URLSearchParams({ mes, ano });
      if (isValid(idRestaurante)) params.append("idRestaurante", idRestaurante);
      if (isValid(idResponsavel)) params.append("idResponsavel", idResponsavel);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/producoes?${params}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Authentication": access_token
          },
        }
      );
      
      if (!response.ok) throw new Error('Erro ao buscar produções');
      return await response.json();
    } catch (error) {
      console.error("Erro ao carregar produções:", error);
      throw error;
    }
  };

  const registrarProducao = async (dadosProducao) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
  
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/producoes?idRestaurante=${dadosProducao.restauranteId}&idResponsavel=${dadosProducao.idResponsavel}`,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Authentication": access_token
          },
          body: JSON.stringify({
            data: dadosProducao.data,
            nome: dadosProducao.nome,
            itens: dadosProducao.itens
          })
        }
      );
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `Erro HTTP: ${response.status} ${response.statusText}`
        );
      }
    } catch (error) {
      // console.error("Erro ao salvar produção xx :", error);
      throw error;
    }
  };
  

  return (
    <ProducaoContext.Provider value={{ buscarProducoes, registrarProducao, today }}>
      {children}
    </ProducaoContext.Provider>
  );
};

export const useProducao = () => useContext(ProducaoContext);